import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=d8f860be&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=js&"
export * from "./SideMenu.vue?vue&type=script&lang=js&"
import style0 from "styles/components/sideMenu.css?vue&type=style&index=0&id=d8f860be&scoped=true&lang=css&"
import style1 from "./SideMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f860be",
  null
  
)

export default component.exports